import { useMutation } from '@apollo/client';
import {
  DTOOLS_AUTHENTICATE, GET_DTOOLS_AUTH_DETAILS,
} from 'src/graphql/entities/integrations/dtools/dtools.operations';
import { DtoolsAuthDetail, DtoolsAuthResponse } from 'src/graphql/entities/integrations/dtools/dtools.types';
import { useGlobalStore } from 'src/store';
import { useNotifications } from 'src/utils/hooks';

export type DtoolsAuthenticateQuery = {
  dtoolsAuthenticate: {
    authDetails: DtoolsAuthDetail & { id: number };
  };
};

export type DtoolsAuthenticateQueryVariables = {
  params: {
    apiKey: string;
  };
};

export const useDtoolsAuthenticate = () => {
  const { showErrorAlert } = useNotifications();
  const selectedPartnerId = useGlobalStore.use.selectedPartnerId();

  const [connect] = useMutation<DtoolsAuthenticateQuery, DtoolsAuthenticateQueryVariables>(
    DTOOLS_AUTHENTICATE,
    {
      optimisticResponse: (vars) => {
        const partnerId = selectedPartnerId ?? Date.now();
        return {
          dtoolsAuthenticate: {
            authDetails: {
              id: partnerId,
              partnerId,
              maskedApiKey: `${vars.params.apiKey.substring(0, 4)}****`,
            },
          },
        };
      },
      update: (cache, result) => {
        const authDetails = result.data?.dtoolsAuthenticate.authDetails;
        if (!authDetails) {
          return;
        }
        const partnerId = authDetails?.partnerId;
        if (partnerId === null || partnerId === undefined) return;
        cache.writeQuery<DtoolsAuthResponse>({
          query: GET_DTOOLS_AUTH_DETAILS,
          variables: {
            params: { partnerId },
          },
          data: {
            getDtoolsAuthDetails: {
              authDetails,
            },
          },
        });
      },
      onError: (data) => {
        showErrorAlert(data.message);
      },
    },
  );

  return {
    connect,
  };
};
